

(function ($) {

  $(document).ready(function() {
    
      // Code for change a tag to button
      $('a[href="#"],a[href=""],[href="javascript:void(0)"],[href="javascript:;"],a:not([href]), .search-form__submit-button, .page-navigation-arrows > a, .product-recommendations .thumbnail__link').attr({
        'role': 'button',
        'aria-label': 'Button'
      });

      $('.dropdown-link ,.size_block .swatch-element, .color_block .swatch-element').attr({
        'tabindex': '0',
        'role': 'button',
      });

      $('.size_block .swatch-element, .color_block .swatch-element').attr({
        'aria-label': 'Button'
      });

      $('.size_block .option-title').attr({
        'aria-label': 'Size Options'
      });

      $('.color_block .option-title').attr({
        'aria-label': 'Color Options'
      });

      // Code for change p tag to heading
      $('.modal_price').attr({
          "role": "heading",
          "aria-level": "2"
      });

      // Code for open link in new tab
      $('a[target="_blank"]').append('<span class="element-screen-only">(Open Link in new window)</span>');

      // Code for footer div to add role footer
      $('.footer-template-section').attr({
          'role': 'contentinfo',
          'aria-label': 'footer'
      });

      $('#search-toggle').attr({
          'aria-label': 'Search Button'
      });

      $('.search-form').attr({
          'role': 'search'
      });

       $('#comment_author,#comment_email').attr({
          'aria-required': 'true'
      });

      // Code for footer div to add role footer
      $('.header,.breadcrumb, .breadcrumb--text').attr({
          'role': 'navigation',
          'aria-label': 'navigation'
      });

       $('.footer_bottum_left > ul').attr({
          'role': 'nav',
      });

      // Code for footer div to add role footer
      $('#content_wrapper').attr({
          'role': 'main',
      });

      // Navigation Aria Hashpoup
      $('.header__nav-item.sub-menu details').attr({
          'aria-haspopup': 'true',
          'aria-expanded': 'false'
      });

      $('body').on('mouseenter', '.sub-menu', function () {
        $('.header__nav-item.sub-menu details').attr('aria-expanded', true);
        $('.header__nav-item.sub-menu details').find('details').attr('open', true);
      });
      $('body').on('mouseleave', '.sub-menu', function () {
        $('.header__nav-item.sub-menu details').attr('aria-expanded', false);
        $('.header__nav-item.sub-menu details').find('details').attr('open', false);
      });

      // role none for elements
      $('svg, .icon-arrow-down, .icon-search, .icon-arrow-right, .truncation-fade, .quick_shop').attr('role', 'none');

      // $('img[alt=""], img:not([alt])').attr('alt', 'image with no alt attributes');

      // Select all images without an alt attribute or with an empty alt attribute
      $('img[alt=""], img:not([alt])').each(function() {
          // Get the image source (name)
          var imgSrc = $(this).attr('src');
          var imgName = imgSrc.substring(imgSrc.lastIndexOf('/') + 1, imgSrc.lastIndexOf('.'));
          
          // Remove numbers and special characters from the image name
          imgName = imgName.replace(/[-_0-9]+/g, ' ').replace(/[^a-zA-Z\s]/g, '');
          
          // Set the alt attribute
          $(this).attr('alt', imgName);
      });

  });

    $('body').on('focus', '.sub-menu', function () {
        $('.header__nav-item.sub-menu details').attr('aria-expanded', true);
        $('.header__nav-item.sub-menu details').find('details').attr('open', true);
      });
      $('body').on('mouseleave', '.sub-menu', function () {
        $('.header__nav-item.sub-menu details').attr('aria-expanded', false);
        $('.header__nav-item.sub-menu details').find('details').attr('open', false);
      });

   $(window).on('load', '.sub-menu', function () {
        $('.header__nav-item.sub-menu details').attr('aria-expanded', false);
      });
   

  // $(window).on('load', '.sloyalty-tab-widget', function() {
  //     $(this).attr('aria-label', 'Iframe');
  // });
  
  $(window).on('load' , function() {

      // Code for change a tag to button
      $('.product-recommendations .thumbnail__link, .swatch').attr({
        'role': 'button',
        'aria-label': 'Button'
      });
    
      // Code for message for screen reader
      $('iframe').attr('aria-label', 'Iframe');

      // role none for elements
      $('svg, .icon-arrow-down, .icon-search').attr('role', 'none');

     $('.promo-banner__close.icon-close').attr({
        'role': 'button',
        'aria-label': 'Button'
      });
    
  });

})(jQuery);
